import React, { Component } from 'react'

import Rodape from './siteComponents/Rodape'
import Cabecalho from './siteComponents/Cabecalho'
import Inicio from './siteComponents/Inicio'
import Servicos from './siteComponents/Servicos'
import Portifolio from './siteComponents/Portifolio'
import Precos from './siteComponents/Precos'
import Contato from './siteComponents/Contato'
import Login from './Views/Login'
import Pagamento from './Views/Pagamento'
import Register from './Views/Register'
import { BrowserRouter, Route } from 'react-router-dom'

class Site extends Component {

    render() {
        return (
            <BrowserRouter>
                <div className="App">
                    <Cabecalho />
                    <Route path='/' exact component={Inicio} />
                    <Route path='/servicos' component={Servicos} />
                    <Route path='/portifolio' component={Portifolio} />
                    <Route path='/precos' component={Precos} />
                    <Route path='/contato' component={Contato} />
                    <Route path='/login' component={Login} />
                    <Route path='/pagamento' component={Pagamento} />
                    <Route path='/registro' component={Register} />
                    <Rodape />
                </div>
            </BrowserRouter>
        )
    }
}

export default Site